import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChange, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import Swal from 'sweetalert2';
import { PromotionsService } from '../../promotions.service';
import {  ViewChild } from '@angular/core';
import { MatOption } from '@angular/material/core';
import { debug } from 'console';
import { CurrencyPipe, formatDate } from '@angular/common';
import { AdminViewService } from 'src/app/framework/services/admin-view.service';


@Component({
  selector: 'app-loyalty-promocode-configuration',
  templateUrl: './loyalty-promocode-configuration.component.html',
  styleUrls: ['./loyalty-promocode-configuration.component.scss'],
  providers: [CurrencyPipe]
})
export class LoyaltyPromocodeComponent extends FeaturesBaseComponent implements OnInit, OnDestroy, OnChanges {
  @Input() loyaltyPromotionsData: any[];
  @Input() codeGroups: [];
  @Input() tiers: [];
  @Input() countries: any;
  loyaltyPromocodesForm: FormGroup;
  isLoyaltyRewardsVisible: boolean = true;
  isLoyaltyEditVisible: boolean = false;
  rowSelection: string;
  searchValue;
  showEditPromotion: boolean = false;
  gridApi: any;
  gridColumnApi: any;
  selectedRows: any;
  providers: any;
  loyaltyId: any;
  loyaltyRewardDetail: any;
  countriesList: any = [];
  submitLabel: string;
  formAction: string;
  isFormUpdate: boolean = false;
  rowData: any[];
  loyaltyPromosDetail: any;
  codeGroupControl = new FormControl();
  pointsControl = new FormControl();
  tierControl = new FormControl();
  countryControl = new FormControl();
  amountControl = new FormControl()
  isButtonDisabled:boolean
  //allSelected: any;
  userTypeFilters: any;
  @ViewChild('allSelected') private allSelected: MatOption;

  constructor(private currencyPipe: CurrencyPipe, private fb: FormBuilder, private router: Router, private promotionService: PromotionsService, private adminViewServices:AdminViewService) {
    super();
    this.isLoyaltyRewardsVisible = true;
    this.isLoyaltyEditVisible = false;
    //this.gridApi.sizeColumnsToFit();

  }

  ngOnInit(): void {
    super.ngOnInit();
    this.initiateForm();
 this.adminViewServices.checkAdminVRole().subscribe((res) => {
      this.isButtonDisabled = res
    })

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['countries']) {
      this.countries = changes['countries'].currentValue;
    }
    if (changes['tiers']) {
      this.tiers = changes['tiers'].currentValue;
    }
    this.countriesList = []
    this.countries.forEach(element => {
      this.countriesList.push(element.countryName)
    });
   

  }


  return() {
    this.isLoyaltyEditVisible = false;
    this.isLoyaltyRewardsVisible = true;
    this.loyaltyPromocodesForm.reset();
    return
  }

  editPromotions() {
    this.formAction = 'pages.placeholders.Edit';
    this.submitLabel = 'pages.placeholders.Update';
    this.isFormUpdate = true;
    this.loyaltyId = this.selectedRows[0].loyaltyPromocodeId;
   

    if (this.loyaltyId && this.loyaltyId) {
      this.promotionService.getLoyaltyPromocodesDataById(this.loyaltyId).subscribe(
        res => {
          this.loyaltyPromosDetail = res['data'];
          this.fillLoyaltyForm(this.loyaltyPromosDetail)
        }
      );
      this.isLoyaltyEditVisible = true;
      this.isLoyaltyRewardsVisible = false;
    }
    // this.router.navigate(['/features/promotions/manage-promo/edit-loyality'])
  }


  addPromotionConfig() {
    this.formAction = 'pages.placeholders.Add';
    this.submitLabel = 'pages.placeholders.Save';
    this.isFormUpdate = false;
    this.isLoyaltyEditVisible = true;
    this.isLoyaltyRewardsVisible = false;
  }

  fillLoyaltyForm(loyaltyRewardDetail: any) {
    
    if (loyaltyRewardDetail == null) {
      this.return();
    }
    //this.loyaltyPromocodesForm.get('codeGroup').setValue(loyaltyRewardDetail.codeGroup)
    this.loyaltyPromocodesForm.get('points').setValue(loyaltyRewardDetail.loyaltyPoints)
    this.loyaltyPromocodesForm.get('tier').setValue(loyaltyRewardDetail.tier)
    //let _selectedCountries: any = loyaltyRewardDetail.country.split(',');
    //
    //this.loyaltyPromocodesForm.get('country').setValue(_selectedCountries)
    this.loyaltyPromocodesForm.get('amount').setValue(loyaltyRewardDetail.promocodeAmount)
  }

  quickSearch() {
    this.gridApi.setQuickFilter(this.searchValue);
  }

  loyalityPromotionsColumnDef: any = [
    { field: 'loyaltyPromocodeId', headerName: 'loyaltyPromocodeId', width: 0, hide: true, sort: "desc" },
    { field: "null", headerName: "Action", checkboxSelection: true, width: 120 },
    { field: 'promocodeAmount', headerName: 'Amount', width: 180, cellRenderer: (data) => {
      return this.currencyPipe.transform(data.value)
    } },
    { field: 'loyaltyPoints', headerName: 'Points', width: 180 },
    { field: 'tier', headerName: 'Tier', width: 180 }
  ]

  onGridReady(params) {
    this.gridApi = params.api;
    //setTimeout(() => { params.api.sizeColumnsToFit() }, 50);
    this.gridColumnApi = params.columnApi;
  }
  onSelectionChanged(e) {
    //;
    this.selectedRows = this.gridApi.getSelectedRows();
    if (this.selectedRows && this.selectedRows != [] && this.selectedRows.length! > 0) {
      this.showEditPromotion = true;
      return
    }
    this.showEditPromotion = false;
  }

  initiateForm = () => {
    this.loyaltyPromocodesForm = new FormGroup({
      //codeGroup: this.codeGroupControl,
      points: this.pointsControl,
      tier: this.tierControl,
      //country: this.countryControl,
      amount: this.amountControl
    })
  }

  get f() {
    return this.loyaltyPromocodesForm.controls;
  }

  onLoyaltyFormSubmit() {
    //;
    if (!this.loyaltyPromocodesForm.valid) {
      return
    }

    if (this.isFormUpdate) {
      
      let _selectedRow = this.selectedRows[0];
      if (_selectedRow.loyaltyPromocodeId == this.loyaltyId) {
        let params = {
          //"codeGroup": this.loyaltyPromocodesForm.get('codeGroup').value,
          //"country": this.loyaltyPromocodesForm.get('country').value,
          "loyaltyPoints": this.loyaltyPromocodesForm.get('points').value,
          "tier": this.loyaltyPromocodesForm.get('tier').value,
          "loyaltyPromocodeCode": _selectedRow.loyaltyPromocodeCode,
          "loyaltyPromocodeDescription": _selectedRow.loyaltyPromocodeDescription,
          "loyaltyPromocodeId": _selectedRow.loyaltyPromocodeId,
          "loyaltyPromocodeName": _selectedRow.loyaltyPromocodeName,
          "promocodeAmount": this.loyaltyPromocodesForm.get('amount').value
        }

        this.promotionService.updateLoyaltyPromocodesConfig(params).subscribe(
          res => {
            if (res['responseStatus'] == 'Success' && res['httpcode'] == 200) {

              this.toastrService.success('Updated successfully', 'Success', {
                timeOut: 3000,
              }); 
              this.getLoyaltyPromoData();
            }
          }
        )
        this.return();
      }
      return
    }
    /*let _countries:any= Array();

    this.countryControl.value.forEach(element => {
     
      if(element != 0){
        _countries.push(element)
      }  
    });*/
    let params =
    {
      //"codeGroup": this.loyaltyPromocodesForm.get('codeGroup').value,
      //"country":  _countries,
      "loyaltyPoints": this.loyaltyPromocodesForm.get('points').value,
      "tier": this.loyaltyPromocodesForm.get('tier').value,
      "promocodeAmount": this.loyaltyPromocodesForm.get('amount').value,
    }
    this.promotionService.addLoyaltyPromocodesConfig(params).subscribe(
      res => {
        if(res.httpcode == 200 && res.responseCodes.find(x => x == "TILA_110") || res.responseStatus == 'Success'){
          this.getLoyaltyPromoData();
          this.toastrService.success('Added successfully', 'Success', {
            timeOut: 3000,
          });        
      }
      }
    )
    this.return()
  }

  getLoyaltyPromoData() {
    this.promotionService.getAllLoyaltyPromotions().subscribe(
      (res) => {
        
        this.loyaltyPromotionsData = res['data']
        this.gridApi.refreshCells();
      }
    )
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
  onCancel() {
    this.isLoyaltyEditVisible = false;
    this.isLoyaltyRewardsVisible = true;
    this.loyaltyPromocodesForm.reset();
    return
  }
  tosslePerOne(all){ 
    if (this.allSelected.selected) {  
     this.allSelected.deselect();
     return false;
 }
   if(this.countryControl.value.length==this.countriesList.length)
     this.allSelected.select();
 } 
  toggleAllSelection() {
    if (this.allSelected.selected) {
      //;
      //;
      //;
      //
      this.countryControl.patchValue([...this.countriesList.map(item => item), 0]);
      //
    } else {
      this.countryControl.patchValue([]);
    }
  }
  checkSubmitDisplayed() {
    return !(this.loyaltyPromocodesForm.valid && !this.loyaltyPromocodesForm.pristine); 
  }  
}
 